<template>
    <!-- 段落标题 -->
    <div @click="setEditIndex(index)">
        <el-row :gutter="10" class="question-box">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title"
                @click="setActiveInput(question.qid)">
                <TitleEditor 
                    :isTest="true"
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="val=>{ question.questionsName = val }" 
				></TitleEditor>
            </el-col>
            <el-col class="edit-btn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
                <OperateaWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="'1'"	
					:question="question"
				></OperateaWrap>
            </el-col>
        </el-row>

    </div>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import OperateaWrap from "./collectToBank/operateaWrap.vue"
    export default {
        components: {
            TitleEditor,
            OperateaWrap
        },
        data() {
            return {

            }
        },
        props: {
            question: {},
            index: {type:Number,default:0}
        },
        computed: {
            ...mapState(['activeInputId']),
        },
        created() {
            if (!this.question.quesCode) {
                this.$set(this.question, 'quesCode', '')
            }
        },
        methods: {
            ...mapActions(['setActiveInput']),
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
        },
    }
</script>

<style scoped lang="scss">
    .inputvalue{
        border: 1px solid rgb(154, 145, 145);
        width: 770px;
        height: 35px;
    }
    .edit-btn-box{    
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .edit-btn{
            font-size: 18px;
            line-height: 30px;
            text-align: right;
            cursor: pointer;
        }
        .edit-btn+.edit-btn{
            margin-left: 15px;
        }
    }
.item .el-badge__content.is-fixed{top:10px;}

    .el_item_option {
        line-height: 40px;
        // height: 44px;
    }

    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }


    .item_container_title {
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin-bottom: 14px;
    }
</style>
